
import React from 'react';
import { Button } from '@/components/ui/button';
import { supabase } from '@/integrations/supabase/client';


type GoogleAuthButtonProps = {
  loading: boolean;
  onError: (message: string) => void;
};

export const GoogleAuthButton: React.FC<GoogleAuthButtonProps> = ({ loading, onError }) => {
  const handleGoogleSignIn = async () => {                                                                                               
    try {                                                                                                                                
      const { data, error } = await supabase.auth.signInWithOAuth({                                                                      
        provider: 'google',                                                                                                              
        options: {                                                                                                                       
          redirectTo: `${window.location.origin}/auth/callback`,                                                                         
          queryParams: {                                                                                                                 
            access_type: 'offline',                                                                                                      
            prompt: 'consent',                                                                                                           
          },                                                                                                                             
        },                                                                                                                               
      });                                                                                                                                
      if (error) throw error;                                                                                                            
    } catch (err: unknown) {
      onError(err instanceof Error ? err.message : String(err));                                                                                                              
    }                                                                                                                                    
  };

  return (
    <Button
      type="button"
      variant="outline"
      className="w-full flex items-center justify-center gap-2 h-9 px-3 text-sm sm:h-10 sm:px-4"
      onClick={handleGoogleSignIn}
      disabled={loading}
    >
      <svg role="img" viewBox="0 0 24 24" className="h-3 w-3 sm:h-4 sm:w-4">
        <path
          fill="currentColor"
          d="M12.48 10.92v3.28h7.84c-.24 1.84-.853 3.187-1.787 4.133-1.147 1.147-2.933 2.4-6.053 2.4-4.827 0-8.6-3.893-8.6-8.72s3.773-8.72 8.6-8.72c2.6 0 4.507 1.027 5.907 2.347l2.307-2.307C18.747 1.44 16.133 0 12.48 0 5.867 0 .307 5.387.307 12s5.56 12 12.173 12c3.573 0 6.267-1.173 8.373-3.36 2.16-2.16 2.84-5.213 2.84-7.667 0-.76-.053-1.467-.173-2.053H12.48z"
        />
      </svg>
      Sign in with Google
    </Button>
  );
};
